import { join, map, replace, reverse, values } from 'lodash';
import commonResource from '../../../locales/th/common.json';
import { LocationItem } from '../../../queries/fragments/project';

class LocationHelper {
  static getZone(data: LocationItem[]) {
    if (data && data.length > 0) {
      const newData = reverse(values(data));
      const mapZone = map(newData, 'label');
      return join(mapZone, ', ');
    }
    return null;
  }

  static getDistrict(data: LocationItem[]) {
    if (data && data.length > 0) {
      const newData = reverse(values(data));
      const mapDistrict = map(newData, 'label');
      return join(mapDistrict, ', ');
    }
    return null;
  }

  static getRoad(data: LocationItem[]) {
    if (data && data.length > 0) {
      const mapRoad = map(data, 'label');
      return mapRoad[0];
    }
    return null;
  }

  static getCoordinate(data: { longitude: number; latitude: number }) {
    const separator = ', ';
    return (
      data.longitude +
      (data.longitude && data.latitude && separator) +
      data.latitude
    );
  }

  static formatDynamicZone(data: { label: string; link: string }[]) {
    if (data && data.length > 0) {
      const zone = map(data, function (value) {
        return {
          label: value.label,
          link: replace(value.link, /zone/g, commonResource.location.zone),
        };
      });
      return zone;
    }
    return null;
  }

  static formatDynamicDistrict(data: { label: string; link: string }[]) {
    if (data && data.length > 0) {
      return map(data, function (value) {
        return {
          label: value.label,
          link: replace(
            value.link,
            /district/g,
            commonResource.location.district,
          ),
        };
      });
    }
    return null;
  }

  static formatDynamicRoad(data: { label: string; link: string }[]) {
    if (data && data.length > 0) {
      return map(data, function (value) {
        return {
          label: value.label,
          link: replace(value.link, /road/g, commonResource.location.road),
        };
      });
    }
    return null;
  }

  static formatDynamicTransportation(data: { label: string; link: string }[]) {
    if (data && data.length > 0) {
      return map(data, function (value) {
        return {
          label: value.label,
          link: replace(value.link, /list/g, 'list/รถไฟฟ้า'),
        };
      });
    }
    return null;
  }
}

export default LocationHelper;
